import Swiper, { Autoplay, Lazy, Pagination } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-promotion-hero-banner-carousel]',
  swiperPagination: '.swiper-pagination',
};

class PromotionHeroBannerCarousel extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.carouselWrappers = this.querySelectorAll(selectors.carouselWrapper);

      this.breakpoint = window.matchMedia('(max-width:1279px)');

      this.init();
    });
  }

  init() {
    this.registerEventListeners();

    this.initCarousels();
  }

  initCarousels() {
    // This only initialises the carousel on load, or if the breakpoint match changes.
    if (this.breakpointMatch !== this.breakpoint.matches) {
      this.breakpointMatch = this.breakpoint.matches;

      if (window.promotion_hero_banner || this.breakpoint.matches) {
        this.carousel = new Swiper(selectors.carouselWrapper, {
          modules: [Autoplay, Lazy, Pagination],
          lazy: true,
          loop: true,
          freeMode: true,
          slidesPerView: 1,
          autoplay: {
            delay: 3000,
          },
          pagination: {
            el: selectors.swiperPagination,
            clickable: true,
          },
        });
      } else if (this.carousel) {
        this.carousel.destroy();

        // Remove pagination because apparently swiper destroy doesn't remove it properly
        this.carouselWrappers.forEach(carouselWrapper => {
          const pagination = carouselWrapper.querySelector(
            selectors.swiperPagination
          );
          pagination.innerHTML = '';
        });
      }
    }
  }

  registerEventListeners() {
    window.addEventListener('resize', () => {
      this.initCarousels();
    });
  }
}

customElements.define(
  'promotion-hero-banner-carousel',
  PromotionHeroBannerCarousel
);
